module.exports = __webpack_public_path__ + "static/media/defaultUser.9575019d.png";